import axios from 'axios';
import { keycloak } from '../../auth';

// URL бэкенда ip.ez.by на legacy сервере
export const IPEZBY_API_URL = 'https://s.ez.by';

export const ipezbyApi = axios.create({
  baseURL: IPEZBY_API_URL,
  timeout: 30_000,
});

// Request interceptor to add Keycloak auth token
ipezbyApi.interceptors.request.use(
  async (config) => {
    if (keycloak.token) {
      try {
        await keycloak.updateToken(30);
      } catch {
        keycloak.login();
        return Promise.reject(new Error('Token refresh failed'));
      }

      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for 401 handling
ipezbyApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      keycloak.login();
    }
    return Promise.reject(error);
  }
);
